export default {

  darkModeState: state => state.layoutMode.dark,
  rtlModeState: state => state.layoutMode.rtl
}
